import { browser } from '$app/environment';
import { writable, get } from 'svelte/store';
import { DARKMODE_KEY, DARKMODE_VALUE, DARKMODE_CLASS, SIDEBAR_OPEN_CLASS } from '$lib/lineone/init';

export const theme = writable<string>(browser ? document.documentElement.getAttribute('data-theme') || 'light' : 'light');
export const dark = writable<boolean>(browser ? document.documentElement.classList.contains('dark') || false : false);
export const mono = writable<boolean>(browser ? document.body.classList.contains('is-monochrome') || false : false);

export const showUnderConstructionModal = writable<boolean>(false);

// DARK MODE CLASS

export const darkModeStorage = writable<string>('');

export const setDarkMode = () => {
	localStorage.setItem(DARKMODE_KEY, DARKMODE_VALUE);
	document.documentElement.classList.add(DARKMODE_CLASS);
	darkModeStorage.update(() => 'dark');
	window.dispatchEvent(
		new CustomEvent('change:darkmode', {
			detail: { currentMode: 'dark' }
		})
	);
};

export const setLightMode = () => {
	localStorage.setItem(DARKMODE_KEY, '');
	document.documentElement.classList.remove(DARKMODE_CLASS);
	darkModeStorage.update(() => 'light');
	window.dispatchEvent(
		new CustomEvent('change:darkmode', {
			detail: { currentMode: 'light' }
		})
	);
};

export const toggleMode = () => {
	get(darkModeStorage) === 'light' ? setDarkMode() : setLightMode();
};

// SIDEBAR TOGGLE

export const closeSidebar = () => {
	const overlayElem = document.querySelector('.overlay');
	document.body.classList.remove(SIDEBAR_OPEN_CLASS);
	document.documentElement.classList.remove('body-sidebar-open');
	overlayElem?.classList.remove('active');
};

export const toggleSidebar = () => {
	const overlayElem = document.querySelector('.overlay');
	document.body.classList.toggle(SIDEBAR_OPEN_CLASS);
	document.documentElement.classList.toggle('body-sidebar-open');
	overlayElem?.classList.toggle('active');
};
